module.exports = __webpack_public_path__ + "static/img/shangla.ec430145.png";